<template>
    <main class="main">
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <the-filters
                        @applyFilters="applyFilters"
                        :filters="filters"
                        :moduleName="'topTen'"
                    />
                </div>

                <div class="col-md-9 mt-5 mt-md-0">
                    <div class="c-page-headline">
                        <sub-section-header title="Top sprzedaży"/>
                    </div>
                    <page-preloader
                        min-height="50vh"
                        :is-loading="true"
                        v-if="status === 'loading'"
                    />
                    <div
                        v-else-if="
                            !chart ||
                                (chart && chart.series[0].data.length === 0)
                        "
                    >
                        Brak danych sprzedażowych spełniających kryteria
                    </div>
                    <div v-else>
                        <stat-chart
                            :chart-options="chart"
                            :refName="refName"
                            :key="keyChart"
                            :series="chart.series"
                            :colors-data="['rgb(4, 125, 54)']"
                            :is-currency="filters.type.value === 'AMOUNT'"
                            :is-quantity="filters.type.value === 'QUANTITY'"
                            :chart-height="
                                (chart.categories.length * 50 + 90).toString()
                            "
                            :chart-width="'95%'"
                            :label-width="getLabelWidth"
                        />
                        <div class="d-flex justify-content-center mt-3">
                            <the-pagination-small
                                :page="pagination.page"
                                :getter="pagination"
                                :setMethod="setPagination"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import moment from 'moment'
import StatChart from '@/components/statistics/StatChart'

export default {
    data() {
        return {
            refName: 'topTenChart',
            keyChart: 0
        }
    },
    computed: {
        filters() {
            return this.$store.getters.getTopTenFilters
        },
        chart() {
            return this.$store.getters.getTopTenForChart
        },
        status() {
            return this.$store.getters.getTopTenStatus
        },
        pagination() {
            return this.$store.getters.getTopTenPagination
        },
        getLabelWidth() {
            return window.innerWidth * 0.25 > 200
                ? 200
                : window.innerWidth * 0.25
        }
    },
    components: {
        StatChart
    },
    methods: {
        resetFilters(filter, value) {
            if (filter === 'startDate' || filter === 'endDate') {
                this.$store.dispatch('setFilter', {
                    filter: 'lastDays',
                    value: null,
                    moduleName: 'topTen'
                })
            } else if (filter === 'lastDays') {
                this.$store.dispatch('setFilter', {
                    filter: 'startDate',
                    value: moment()
                        .subtract(value, 'days')
                        .format('YYYY-MM-DD HH:mm:ss'),
                    moduleName: 'topTen'
                })
                this.$store.dispatch('setFilter', {
                    filter: 'endDate',
                    value: moment().format('YYYY-MM-DD HH:mm:ss'),
                    moduleName: 'topTen'
                })
                setTimeout(() => {
                    this.$store.dispatch('setFilter', {
                        filter: 'lastDays',
                        value: value,
                        moduleName: 'topTen'
                    })
                }, 0)
            }
        },
        applyFilters(payload) {
            /* eslint-disable eqeqeq */
            this.resetFilters(payload.filter, payload.value)
            if (
                this.$router.currentRoute.query.page &&
                this.$router.currentRoute.query.page != 1
            ) {
                this.$router
                    .push({ query: { ...this.$route.query, page: 1 } })
                    .then(() => {
                        this.fetch()
                    })
            } else {
                this.fetch()
            }
        },
        fetch() {
            return this.$store.dispatch('topTenFetch')
        },
        setPagination(page) {
            this.$store.dispatch('setTopTenPagination', {
                ...this.pagination,
                page: page.toString(),
                prevPage: page > 1 ? page - 1 : '',
                nextPage: page < this.pagination.totalPages ? page + 1 : ''
            })
        }
    },
    created() {
        this.$nextTick(() => {
            this.$store.dispatch('devicesFetch').then(() => {
                setTimeout(() => {
                    this.fetch()
                }, 0)
            })
        })
    },
    watch: {
        chart() {
            this.keyChart++
        }
    }
}
</script>
